export const isValidPath = (path?: string) => {
    if (typeof path !== 'string') return false;
    try {
        return !decodeURIComponent(path).includes('%');
    } catch (error) {
        return false;
    }
};
